module.exports = __webpack_public_path__ + "media/application/images/icons/green-arrow-right-9224a303d628967acaf1791a86f5902a.svg";